import { useState } from 'react';
import { useToast } from '../context/ToastContext';
import { useAuth } from '../context/AuthContext';
import { PLANS, pstat } from '../data/mockData';
import ProgTypeTag from '../components/ProgTypeTag';

const PERMISSIONS = [
  'Create & edit tourism programme deployment plans',
  'Assign lecturers, guides, and specialist rooms',
  'Use AI Agent for conflict resolution and content',
  'Submit plans for Academic Head approval',
  'Track STB licence validity for guide trainers',
  'View full reports and analytics',
];

function initials(name = '') {
  return name.split(' ').slice(0, 2).map((w) => w[0] || '').join('').toUpperCase();
}

export default function ProfilePage() {
  const { user, displayRole } = useAuth();
  const { show } = useToast();
  const [name, setName] = useState(user?.name || '');
  const [email, setEmail] = useState(user?.email || '');

  const myPlans = PLANS.filter((p) => p.by === 'Sarah Tan');

  return (
    <div>
      <div className="p-banner">
        <div className="p-ava">{initials(user?.name)}</div>
        <div className="p-name">{user?.name}</div>
        <div className="p-role">{displayRole} — Tourism &amp; Hospitality <span>AY2026 Sem 1</span></div>
      </div>
      <div className="g2" style={{ alignItems: 'start' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.3rem' }}>
          <div className="card">
            <div className="ct">Personal Information</div>
            <div className="fg"><label className="fl">Full Name</label><input className="finput" value={name} onChange={(e) => setName(e.target.value)} /></div>
            <div className="fg"><label className="fl">Email</label><input className="finput" value={email} onChange={(e) => setEmail(e.target.value)} /></div>
            <div className="fg"><label className="fl">Department</label><input className="finput" defaultValue="School of Tourism &amp; Hospitality Management" /></div>
            <div className="fg"><label className="fl">Staff ID</label><input className="finput" defaultValue="TMIS-2023-AP018" readOnly style={{ background: 'var(--cloud)', color: 'var(--slate)' }} /></div>
            <button className="btn btn-primary btn-sm" onClick={() => show('Profile updated', 'success')}><i className="fa-solid fa-floppy-disk" /> Save Changes</button>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.3rem' }}>
          <div className="card">
            <div className="ct">Role &amp; Permissions</div>
            <div style={{ background: 'var(--ocean-dk)', borderRadius: 9, padding: '1rem', marginBottom: '1rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '.48rem' }}><span style={{ fontSize: 'var(--text-sm)', color: 'rgba(255,255,255,.5)' }}>Role</span><span style={{ fontSize: 'var(--text-sm)', fontWeight: 700, color: 'var(--gold-bg)' }}>{displayRole}</span></div>
              {/* var(--ocean-dk) box stays dark in both themes, but var(--surface)
                  flips to near-black in dark mode — was invisible there; the
                  fixed white the sibling rows already use is what's meant. */}
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '.48rem' }}><span style={{ fontSize: 'var(--text-sm)', color: 'rgba(255,255,255,.5)' }}>Institute</span><span style={{ fontSize: 'var(--text-sm)', fontWeight: 600, color: '#fff' }}>Tourism Management Institute of Singapore</span></div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ fontSize: 'var(--text-sm)', color: 'rgba(255,255,255,.5)' }}>Last Login</span><span style={{ fontFamily: 'var(--font-mono)', fontSize: '.75rem', color: 'rgba(255,255,255,.65)' }}>13 Oct 2026 09:15</span></div>
            </div>
            {PERMISSIONS.map((p) => (
              <div key={p} style={{ display: 'flex', alignItems: 'center', gap: '.55rem', padding: '.42rem 0', borderBottom: '1px solid var(--border-soft)', fontSize: 'var(--text-sm)', color: 'var(--ink-s)' }}>
                <i className="fa-solid fa-circle-check" style={{ color: 'var(--sea)', fontSize: '.82rem', flexShrink: 0 }} />{p}
              </div>
            ))}
          </div>
          <div className="card">
            <div className="ct">My Deployment Plans</div>
            {myPlans.map((p) => (
              <div key={p.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '.62rem 0', borderBottom: '1px solid var(--border-soft)' }}>
                <div>
                  <div style={{ fontSize: 'var(--text-sm)', fontWeight: 600, color: 'var(--ink)' }}>{p.name}</div>
                  <div style={{ fontSize: 'var(--text-sm)', color: 'var(--slate)', marginTop: '.1rem' }}><ProgTypeTag type={p.type} /></div>
                </div>
                <span className={`pill ${pstat(p.status)}`}>{p.status}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
